import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoPosseTerraEnum } from 'graphql/types.generated'

import { tipoPosseTerraEnumRecord } from './condicoes-moradia-model'

type TipoPosseTerraSelectFieldProps = CustomSelectFieldProps<TipoPosseTerraEnum>

export function TipoPosseTerraSelectField(props: TipoPosseTerraSelectFieldProps) {
  return <SelectField<TipoPosseTerraEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.values(TipoPosseTerraEnum)
const itemToString = (item: TipoPosseTerraEnum) => item && tipoPosseTerraEnumRecord[item]
